import React from 'react';
import { Box } from '@chakra-ui/react';

import colors from '../../../styles/theme/foundation/colors';

function InsurancePolicyCard({ children, isArchived = false }) {
  const baseStyles = {
    flexBasis: '100%',
    marginBottom: '1rem',
    paddingLeft: '0.75rem',
    paddingRight: '0.75rem',
    paddingTop: '1rem',
    paddingBottom: '1rem',
    borderRadius: '10px'
  };

  const styles = isArchived ? {
    ...baseStyles,
    backgroundColor: colors.greyScale['100']
  } : {
    ...baseStyles,
    backgroundColor: 'white',
    borderColor: colors.greyScale['200'],
    borderWidth: '1px'
  };

  return (
    <Box style={styles}>
      {children}
    </Box>
  );
}

export default InsurancePolicyCard;
